import '../stylesheets/scenarios.scss'

import Choices from 'choices.js';
import 'choices.js/src/styles/choices.scss';
import imagesLoaded from "imagesloaded/imagesloaded.pkgd.min";
import LazyLoad from "vanilla-lazyload";
import Masonry from 'masonry-layout';
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

document.addEventListener("turbo:load", function () {
  // Choices.js
  document.querySelectorAll('[data-toggle="select2"]').forEach(function (element) {
    new Choices(element, {
      itemSelectText: '',
      removeItems: true,
      removeItemButton: true,
      noChoicesText: '沒有可選擇的標籤',
      searchEnabled: true
    });

    document.querySelectorAll('.choices__group .choices__heading').forEach(function (element) {
      element.innerHTML == "" ? element.parentElement.classList.add('d-none') : null;
    });
  });


  // Masonry
  // var grid = document.querySelector('.masonary-layout');
  // new Masonry(grid, {
  //   percentPosition: true
  //   // itemSelector: '.grid-item',
  //   // columnWidth: 200
  // });

  var grid = document.querySelector('.masonary-layout');
  var msnry;

  imagesLoaded(grid, function () {
    console.log('all images are loaded');
    // init Isotope after all images have loaded
    msnry = new Masonry(grid, {
      // itemSelector: '.grid-item',
      // columnWidth: '.grid-sizer',
      percentPosition: true
    });

    msnry.layout()
  });

  (function () {
    var callback_loaded = function (element) {
      msnry.layout()
    };

    var ll = new LazyLoad({
      callback_loaded: callback_loaded
    });
  })();

  const swiper = new Swiper('.swiper', {
    // Optional parameters
    slidesPerView: 4,
    centerInsufficientSlides: true,
    loop: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      320: {
        // spaceBetween: 10,
        slidesPerView: 1
      },
      768: {
        spaceBetween: 5,
        slidesPerView: 4
      }
    }

    // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });
})
